import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgWarning({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.543 3.496a3 3 0 013.986 1.008l.093.158 6.601 11.881a3 3 0 01-2.446 4.452l-.176.005H5.399a3 3 0 01-2.706-4.294l.084-.163 6.6-11.881a3 3 0 011.166-1.166zm8.932 14.018l-6.6-11.881a1 1 0 00-1.69-.095l-.06.095-6.6 11.881a1 1 0 00.747 1.478L5.4 19h13.202a1 1 0 00.929-1.37l-.055-.116-6.6-11.881 6.6 11.881zM12 11.5a1 1 0 01.993.884L13 12.5v4a1 1 0 01-1.993.117L11 16.5v-4a1 1 0 011-1zM12 8a1 1 0 110 2 1 1 0 010-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgWarning
